import SyncTimestamp from "../common/SyncTimestamp";

const productsSyncTimestamp = new SyncTimestamp("productview");

export default productsSyncTimestamp;
